import { render, staticRenderFns } from "./jibenxinxi.vue?vue&type=template&id=5c240354&scoped=true&"
import script from "./jibenxinxi.vue?vue&type=script&lang=ts&"
export * from "./jibenxinxi.vue?vue&type=script&lang=ts&"
import style0 from "./jibenxinxi.vue?vue&type=style&index=0&id=5c240354&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c240354",
  null
  
)

export default component.exports